import { styled } from '@mui/material';

export const StyledPageTitle = styled('div')`
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    padding: 5px 0px;
`;
